import { Trans, useTranslation } from "react-i18next";

import useNoEligibleProductsYet from "@/hooks/useNoEligibleProductsYet";
import { DetailTribeResponse } from "@/services/model";

export const GroupOverviewContent = ({
  tribeDetail,
  currentDiscount,
  isTribeFull,
}: {
  tribeDetail: DetailTribeResponse;
  currentDiscount: string;
  isTribeFull?: boolean;
}) => {
  const { t } = useTranslation("portal", {
    keyPrefix: "friendsWithBenefits",
  });

  const nextLevelDiscount = tribeDetail?.tribeDiscountNext
    ? `${tribeDetail.tribeDiscountNext}%`
    : "0%";

  const maxDiscountReached = currentDiscount === "30%";

  const noEligibleProductsYet = useNoEligibleProductsYet();

  return (
    <div className="mb-8 text-xl">
      {isTribeFull ? (
        <>
          <p className="mb-6 font-semibold text-secondary-100">
            {t("groupOverview.tribeFull.title")}
          </p>
          <p className="mb-6">
            <Trans
              t={t}
              i18nKey="groupOverview.tribeFull.discount"
              components={[
                <span
                  key="percentage"
                  className="font-semibold text-primary-100"
                />,
              ]}
              values={{
                percentage: currentDiscount,
              }}
            />
          </p>
          <p>{t("groupOverview.tribeFull.limitReached")}</p>
        </>
      ) : (
        <div>
          {maxDiscountReached ? (
            <>
              <Trans
                t={t}
                i18nKey="groupOverview.tribeFull.discount"
                components={[
                  <span
                    key="percentage"
                    className="font-semibold text-primary-100"
                  />,
                ]}
                values={{
                  percentage: currentDiscount,
                }}
              />
              <p className="mt-4">{t("groupOverview.maxDiscountReached")}</p>
            </>
          ) : (
            <Trans
              t={t}
              i18nKey="groupOverview.upsell"
              count={noEligibleProductsYet ? 2 : 1}
              components={[
                <span
                  key="percentage"
                  className="font-semibold text-primary-100"
                />,
                <span key="count" className="font-semibold text-primary-100" />,
                <span
                  key="nextPercentage"
                  className="font-semibold text-primary-100"
                />,
              ]}
              values={{
                percentage: currentDiscount,
                // For the first discount increase, there need to be 2 members or products in the tribe
                count: noEligibleProductsYet ? 2 : 1,
                nextPercentage: noEligibleProductsYet
                  ? "5%"
                  : nextLevelDiscount,
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};
